import React, { createContext, useState, useEffect, useContext } from "react";
import { userService } from "../services/api";
import Cookies from "universal-cookie";
// Création du contexte d'authentification
export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Vérifier si l'utilisateur est déjà connecté au chargement
  useEffect(() => {
    const cookies = new Cookies();
    const token = cookies.get("token");
    if (token) {
      fetchCurrentUser();
    } else {
      setLoading(false);
    }
  }, []);

  // Récupérer les informations de l'utilisateur connecté
  const fetchCurrentUser = async () => {
    const cookies = new Cookies();
    try {
      const response = await userService.getCurrentUser();
      setCurrentUser(response.data);
    } catch (err) {
      console.error("Erreur lors de la récupération de l'utilisateur:", err);
      cookies.remove("token");
    } finally {
      setLoading(false);
    }
  };

  // Fonction de connexion
  const login = async (credentials) => {
    try {
      const cookies = new Cookies();
      setError(null);
      const response = await userService.login(credentials);
      const token = response.data.token;
      if (!token) {
        setError("Aucun token reçu");
        return false;
      }
      cookies.set("token", token, {
        expires: new Date(Date.now() + 3600 * 1000 * 24),
      }); 
      const t = cookies.get("token");
      if (!t) {
        setError("Aucun token trouvé dans le stockage local");
        return false;
      }
      await fetchCurrentUser();
      return true;
    } catch (err) {
      setError(err.response?.data?.non_field_errors || "Échec de connexion");
      return false;
    }
  };

  // Fonction de déconnexion
  const logout = () => {
   const cookies = new Cookies();

    console.log("Avant :", cookies.get("token"));

    cookies.remove("token", { path: "/" });

    console.log("Après :", cookies.get("token"));

   setCurrentUser(null);
  };

  // Fonction d'inscription
  const register = async (userData) => {
    try {
      setError(null);
      await userService.register(userData);
      const cookies = new Cookies();
      const loginResponse = await userService.login({
        username: userData.username,
        password: userData.password,
      });
      cookies.set("token", loginResponse.data.token, {
        expires: new Date(Date.now() + 3600 * 1000 * 24),
      }); // 1 heure
      await fetchCurrentUser();
      return true;
    } catch (err) {
      setError(err.response?.data || "Échec d'inscription");
      return false;
    }
  };

  // Valeurs exposées par le contexte
  const value = {
    currentUser,
    loading,
    error,
    login,
    logout,
    register,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Hook personnalisé pour utiliser le contexte d'authentification
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error(
      "useAuth doit être utilisé à l'intérieur d'un AuthProvider"
    );
  }
  return context;
};
